/**
 * for `PreviewFlashcardCard` or `MasteryFlashcardCard` to give outer padding to make a gap between cards
 * since `Virtuoso` does not support margin calculation
 */
const ListPadWrapper = ({
    children,
    isFirst,
    isLast,
    style,
    ...divProps
}: {
    children: React.ReactNode;
    isFirst?: boolean;
    isLast?: boolean;
} & React.HTMLAttributes<HTMLDivElement>) => {
    return (
        <div style={{ padding: isFirst ? "0 0 1.5rem" : isLast ? "1.5rem 0 0" : "1.5rem 0", ...style }} {...divProps}>
            {children}
        </div>
    );
};

export default ListPadWrapper;
